import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ManageTicketServiceService {

  constructor(public http: HttpClient) { }
  getTickets(secretKey, userId, orgId, usertType, priority, category, type, assignedTo, status, fp): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('secretkey', secretKey);
    headers = headers.append('userId', userId);
    var params = new HttpParams();

    var userType = localStorage.getItem('userType');
    var authid = localStorage.getItem('authorizedUserId');
    let authuserid = '';
    if (userType == 'User Member' || userType == 'User Member Manager') {
      authuserid = authid;
    } else {
      authuserid = userId;
    }
    params = params.append('priority', priority);
    params = params.append('category', category);
    params = params.append('type', type);
    params = params.append('assignedTo', assignedTo);
    params = params.append('status', status);
    params = params.append('fp', fp);
    var options = {
      headers: headers,
      params: params
    }
    var url = environment.url + 'ticket/' + authuserid + '/' + orgId + '/' + usertType;
    return this.http.get(url, options);
  }
  ticketFilter(orgId, status, usertType): Observable<any> {
    var secretKey = localStorage.getItem('secretkey');
    var userId = localStorage.getItem('userId');
    let headers = new HttpHeaders();
    headers = headers.append('secretkey', secretKey);
    headers = headers.append('userId', userId);
    var url = environment.url + 'ticketFilter/' + orgId + "/" + status + "/" + usertType + "/" + userId + '/' + 'self';
    return this.http.get(url, { headers: headers });
  }
  deleteTicket(userId, id, secretKey): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('secretkey', secretKey);
    headers = headers.append('userId', userId);
    var obj = {
      "modified_by": userId
    }

    var url = environment.url + 'deleteTicket/' + id;
    return this.http.put(url, obj, { headers: headers });
  }

  getUsers(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('secretkey', localStorage.getItem('secretkey'));
    headers = headers.append('userId', localStorage.getItem('userId'));

    var url = environment.url + 'getUserList/' + localStorage.getItem('userId') + '/' + localStorage.getItem('userType');
    return this.http.get(url, { headers: headers });
  }
}
